import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  getHcpConsentPayload,
  SelectedHcpConsentState,
} from '../types/hcpConsent.types'

const initialState: SelectedHcpConsentState = {
  selected: null,
}

const hcpConsentSlice = createSlice({
  name: 'hcpConsent',
  initialState: initialState,
  reducers: {
    getAllHcpConsent: (
      state: SelectedHcpConsentState,
      _action: PayloadAction<getHcpConsentPayload>
    ) => {
      return state
    },

    updateHcpData: (state, action) => {
      state.selected = action.payload
    },

    putHcpConsentData: (state, _action) => {
      return state
    },
  },
})

export const { getAllHcpConsent, updateHcpData, putHcpConsentData } =
  hcpConsentSlice.actions
export default hcpConsentSlice.reducer
